export default [
	{
    id : "MSG0",
		from: {
			key: 1,
			email: 'ceo@company.it',
			fullName: 'CEO - Mr. Emilio Ferrari',
			avatar: 'ceo'
		},
		isRead: false,
		subject: 'Welcome on board!',
		message:
			'I am looking forward to getting your feedback about my new business venture. I need your expertise to decide about some crucial aspects in the Sales, Production and Procurement areas and to understand whether Eris would be feasible and profitable for our company.\n\nDon’t forget to check in with me and other EGi’s managers by submitting your business plan twice before the deadline of your project. \n\nI sincerely Thank You on behalf of the entire Company.\n\n\n\nEmilio Ferrari'
	}
];
